export const MSME_DRAWER_TITLE = 'MSME Payment Delay';
export const MSME_DELAY_BUTTON_LABEL = 'Delay Details';
export const MSME_DRAWER_WIDTH = '39.625rem';
export const MSME_GRID_FY_COUNT = 3;
export const MSME_EMPTY_CELL = '–';

/** Indian FY month order, as `monthsEnum` keys. */
export const FY_MONTH_KEYS = ['04', '05', '06', '07', '08', '09', '10', '11', '12', '01', '02', '03'];

export const MSME_DRAWER_COLUMNS = {
    FINANCIAL_YEAR: 'Financial Year',
    PAN: 'PAN',
    AMOUNT: 'Amount',
} as const;

export const MSME_AMOUNT_SORT_FIELD = 'amount';

export const MSME_EXPAND_SUPPLIERS_LABEL = 'Show suppliers for';

export const ARIA_SORT_BY_DIRECTION = {
    ASC: 'ascending',
    DESC: 'descending',
} as const;
